var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column justify-center",staticStyle:{"width":"100%"}},[_c('v-container',{staticClass:"d-flex flex-column",staticStyle:{"max-width":"1480px"}},[(_vm.contentTemplate !== '')?_c({
        name: 'dynamic-content',
        template: this.contentTemplate,
      },{tag:"component"}):_vm._e()],1),_c('foo-ter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }